module.exports = __webpack_public_path__ + "static/media/ax.ee747508.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ax.svg
// module id = 56
// module chunks = 0